var React = require('react');

function CheckIconThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7 13.667.964 2.055c.764 1.628 3.044 1.721 3.94.162L17 7","stroke":"currentColor","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckIconThin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckIconThin;

CheckIconThin.default = CheckIconThin;
